<div class="popout-container">
    <div class="popout-header">
        <div class="popout-title">
            <img src="assets/icons/desktop/ScoutAI_Desktop_Icon.svg" alt="Scout AI" class="scout-ai-icon-header">
            <span>Navigator-Scout</span>
        </div>
        <div class="popout-actions">
            <button (click)="dockToDrawer()" class="scout-ai-btn-icon" aria-label="Return to main window" title="Return to main window">
                <i class="fa-solid fa-down-left-and-up-right-to-center"></i>
            </button>
            <button (click)="closeWindow()" class="scout-ai-btn-icon" aria-label="Close" title="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
    </div>

    <div class="popout-content">
        <app-scout-ai-session></app-scout-ai-session>
    </div>
</div>
